import React, { useContext } from 'react';

var FlightsRenderStateContext = React.createContext({ deferRerender: false });
var FlightsRenderStateProvider = FlightsRenderStateContext.Provider;
function useFlightsRenderStateProvider() {
    return useContext(FlightsRenderStateContext);
}

var FlightsFaresContext = React.createContext({ displayPmp: true });
var FlightsFaresContextProvider = FlightsFaresContext.Provider;
function useFlightsFaresContextProvider() {
    return useContext(FlightsFaresContext);
}

export { FlightsFaresContextProvider, FlightsRenderStateProvider, useFlightsFaresContextProvider, useFlightsRenderStateProvider };
